import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuth } from '../auth/useAuth';

export const Route = createFileRoute('/login')({
  beforeLoad: ({ context }) => {
    if (context.msalInstance.getAllAccounts().length > 0) {
      throw redirect({ to: '/' });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { login } = useAuth();
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: 24 }}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <h1 style={{ fontSize: 28, marginBottom: 8 }}>Accounting</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
          Sign in with your Microsoft account to continue.
        </p>
        <button className="btn-primary" onClick={() => void login()}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
